import { HttpErrorResponse } from '@angular/common/http';
import { CartItems } from './../../models/cart-order';
import { CartItem } from './../../models/cart-item';
import { PaymentService } from './../../services/payment.service';
import { ProviderItemInputs } from './../../models/provider-item-inputs';
import { Commission } from './../../models/commission';
import { ProviderDetails } from 'src/app/models/provider-details';
import { Component, OnInit } from '@angular/core';
import { ProvidersService } from 'src/app/services/providers.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { CartOrder } from 'src/app/models/cart-order';
import { PaymentProviderInputs } from 'src/app/models/paymentItem';
import { Language } from './../../util/lang';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-check-provider',
  templateUrl: './check-provider.component.html',
  styleUrls: ['./check-provider.component.scss']
})
export class CheckProviderComponent implements OnInit {
  public guid: string;
  public showLoading: boolean = false;
  public providerDetails: ProviderDetails;
  public providerItemInputs: ProviderItemInputs[];
  public providerName: string;
  public commissions: Commission[];
  public form: FormGroup;
  public amount: number = 0;
  public commissionAmount: string;
  public formUrl: string;
  public buttonDisabled: boolean = false;
  public showPopup: boolean = false;
  public popupMessage: string;
  public popupMessages: ProviderItemInputs[];
  public amountFromRedirect: number;

  constructor(
    public providersService: ProvidersService,
    public paymentService: PaymentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      const { id } = params;
      let guid;
      if (id.includes('?')){
        const splitArray = id.split('?');
        guid = splitArray[0];
        this.amountFromRedirect = splitArray[1];
      }
      else {
        guid = id;
      }
      let path;
      this.activatedRoute.url.subscribe(route => {
        path = route[1].path;
      });
      this.init(guid, path);

    });
  }

  public async getCommissions(id): Promise<void> {
    const currency = this.providersService.getCurrency() ? this.providersService.getCurrency() : 'AMD';
    this.providersService.getCommissions(id, currency).subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        this.router.navigate([`${Language.getCurrentLang()}/provider/${this.guid}`]);
      } else {
        this.commissions = response;
        this.setCommission();
      }
    });
  }

  public async getProviderInfo(id): Promise<void> {
    this.providersService.getProviderInfo(id).subscribe(response => {
      if (response instanceof HttpErrorResponse) {
        this.router.navigate([`${Language.getCurrentLang()}/provider/${this.guid}`]);
      }
      else {
        const { Name } = response.Object;
        this.providerName = Name;
      }
    });
  }

  public setAmount(): void {
    const currency = this.providersService.getCurrency();
    const { Debt, MinAmount, MaxAmount, RangeByCurrency } = this.providerDetails;
    let min;
    let max;
    let amount;
    const debt = Debt;
    if (currency && RangeByCurrency) {
      const { AmountStart, AmountEnd } = RangeByCurrency.filter(el => el.Currency == currency)[0];
      min = AmountStart;
      max = AmountEnd;
    } else {
      min = MinAmount;
      max = MaxAmount;
    }
    if (debt > MaxAmount) {
      amount = MaxAmount;
    } else if (debt < min) {
      amount = min;
    } else {
      amount = debt;
    }
    if (this.amountFromRedirect){
      this.amount = this.amountFromRedirect;
    } else {
      this.amount = Math.ceil(amount * 10) / 10;
    }
  }

  public validate(paymentProviderInputs: PaymentProviderInputs[]): ProviderItemInputs[] {
    const items: ProviderItemInputs[] = [];
    paymentProviderInputs.forEach(i => {
      if (i.providerInputId != 0) {
        items.push(new ProviderItemInputs(i.providerInputId.toFixed(), i.value))
      }
    });
    return items;
  }

  public async standardCase(id: string): Promise<void> {
    const { providerDetails, providerItemInputs } = this.providersService.getProviderDetails();
    this.providerDetails = providerDetails;
    this.providerItemInputs = providerItemInputs;
    this.guid = id;
    if (!providerDetails) {
      this.router.navigate([`${Language.getCurrentLang()}/provider/${this.guid}`]);
      return;
    };
  }

  public async fromUrlCase(id: string) {
    this.providersService.getItem(id).subscribe(itemResponse => {
      if (itemResponse instanceof HttpErrorResponse || !itemResponse) {
        this.router.navigate([`${Language.getCurrentLang()}/notfound`]);
      } else {
        this.providerItemInputs = this.validate(itemResponse.paymentProviderInputs);
        this.guid = itemResponse.paymentProviderGUID;
        this.providersService.checkProviderItemInputs(this.providerItemInputs).subscribe(response => {
          if (response instanceof HttpErrorResponse || response.status === 400) {
            this.router.navigate([`${Language.getCurrentLang()}/notfound`]);
          }
          else {
            this.providerDetails = response;
            this.setValues();
          }
        });
      }
    });
  }

  public init(id: string, path: string): void {
    if (id && path === `pay`) {
      this.standardCase(id).then(() => {
        this.setValues();
      });
    } else if (id && path === "prepayment") {
      this.fromUrlCase(id);
    }
  }

  public setValues(): void {
    this.getCommissions(this.guid).then(() => {
      this.getProviderInfo(this.guid);
    }).then(() => {
      this.setAmount();
    }).then(() => {
      this.form = new FormGroup({
        amount: new FormControl(this.amount)
      });
    }).catch((err) => { });
  }

  public setCommission(): void {
    const value = this.amount;
    let commissionAmount = 0;
    this.commissions.forEach((commission) => {
      const { AmountStart, AmountEnd, Fixed, Percentage, PercentageMaxAmount, PercentageMinAmount } = commission;
      if (value >= AmountStart && value <= AmountEnd) {
        if (Fixed > 0) {
          commissionAmount = Fixed;
        } else {
          commissionAmount = value * Percentage / 100;
          if (commissionAmount > PercentageMaxAmount) {
            commissionAmount = PercentageMaxAmount;
          } else if (commissionAmount < PercentageMinAmount) {
            commissionAmount = PercentageMinAmount;
          }
        }
      }
    });
    this.commissionAmount = commissionAmount.toFixed(1);
  }

  public onSubmit() {

    const currentLang = Language.getCurrentLang();
    const formData = this.form.getRawValue();
    const { amount } = formData;
    this.showLoading = true;
    const currency = this.providersService.getCurrency();
    const sessionData = this.providersService.getSessionData() ? this.providersService.getSessionData() : null;
    if (sessionData) this.providerItemInputs.push(sessionData);
    const { MinAmount, MaxAmount, RangeByCurrency } = this.providerDetails;
    let min;
    let max;
    if (currency && RangeByCurrency) {
      const { AmountStart, AmountEnd } = RangeByCurrency.filter(el => el.Currency == currency)[0];
      min = AmountStart;
      max = AmountEnd;
    } else {
      min = MinAmount;
      max = MaxAmount;
    }

    if (amount > max || amount < min) {
      const message = currentLang == "en" ? `Minimal value is ${min}, maximal value is ${max}` : (currentLang == 'hy' ?
        `Մինիմալ արժեքն է ${min}, առավելագույն արժեքն է ${max}` : `Mинимальное значение ${min}, максимальное значение значение ${max}`);
      this.popupMessage = message;
      this.showPopup = true;
      this.showLoading = false;
    }
    else {
      const curr = this.providersService.getCurrency() ? this.providersService.getCurrency() : 'AMD';
      this.paymentService.addCartItem(new CartItem(amount.toString(), parseFloat(this.commissionAmount), curr, this.guid, this.providerItemInputs))
        .subscribe(cartItemResponse => {
          if (cartItemResponse instanceof HttpErrorResponse) {
            alert('Փորձեք մի փոքր ուշ'); // todo
            this.showLoading = false;
          }
          else {
            const cartItems: CartItems[] = [];
            cartItems.push(new CartItems(cartItemResponse))
            this.paymentService.addCartOrderSync(new CartOrder(null, cartItems, 'Payment system', '1')).subscribe(cartOrderResponse => {
              if (cartOrderResponse instanceof HttpErrorResponse) {
                alert('Փորձեք մի փոքր ուշ'); // todo
                this.showLoading = false;
              }
              else {
                this.formUrl = cartOrderResponse.FormUrl;
                window.open(this.formUrl, "_blank");
                this.router.navigate([`${Language.getCurrentLang()}/paymenthistory`]);
                this.buttonDisabled = true;
                this.showLoading = false;
              };
            });
          };
        });
    };
  }

  public onKeyUp(event) {
    const { value } = event.target;
    this.amount = value;
    this.setCommission();
  }
}
